'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What types of mobile apps do you develop?",
    answer: "We build all kinds of mobile apps — from eCommerce and service-based apps to gaming, booking, education, and custom enterprise apps. Whether it’s B2B or B2C, we turn your idea into a fully functional app."
  },
  {
    question: "Do you develop for both Android and iOS platforms?",
    answer: "Yes, we offer both native and cross-platform development. Using tools like Flutter and React Native, we create apps that work seamlessly on Android and iOS with a single codebase when needed."
  },
  {
    question: "How much time does it take to develop a mobile app?",
    answer: "A basic app can take around 3–5 weeks, while more advanced apps with complex features may take 2–3 months. We provide a detailed timeline after understanding your specific requirements."
  },
  {
    question: "Can you also help with app design and publishing on Play Store or App Store?",
    answer: "Absolutely! We handle UI/UX design, development, testing, and app store submission. From concept to launch, we guide you through every step, including store optimization and approvals."
  },
  {
    question: "Will I receive updates and support after the app is live?",
    answer: "Yes, we provide complete post-launch support including bug fixes, updates, feature enhancements, and performance monitoring. Your app’s long-term success is just as important to us as its launch."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className='col text-center py-5 mt-5' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level="3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
                        className={`transition-colors duration-200 cursor-pointer 
                          hover:text-purple-600 
                          ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
                      >{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
